<template>
	<div class="omapi-card__flex omapi-dash__top">
		<common-card class="omapi-dash__top" title="Top Converting Campaigns" type="minimize">
			<core-loading v-if="isLoading"></core-loading>
			<div v-else>
				<ul
					v-if="hasCampaigns && connected"
					class="omapi-detailed-list"
				>
					<li v-if="!topCampaigns.length">
						No data to show at this time.
					</li>
					<li
						v-else
						v-for="(campaign) in topCampaigns"
						:key="`top-campaign-${campaign.campaign_id}`"
					>
						<div class="omapi-multi-column__primary">
							<div class="omapi-multi-column__title">
								<a :href="builderLink(campaign.campaign_id)" class="omapi-link-title">{{ campaign.name }}</a>
							</div>
							<ul class="omapi-multi-column__meta">
								<li><span class="omapi-multi-column__meta-attr">Visitors: </span><span class="omapi-multi-column__meta-value">{{ withCommas(campaign.impressions) }}</span></li>
								<li><span class="omapi-multi-column__meta-attr">Conversions: </span><span class="omapi-multi-column__meta-value">{{ withCommas(campaign.conversions) }}</span></li>
								<li><span class="omapi-multi-column__meta-attr">CR%: </span><span class="omapi-multi-column__meta-value">{{ getRate(campaign.rate) }}</span></li>
							</ul>
						</div>
					</li>
				</ul>
				<common-no-campaigns
					v-else-if="!hasCampaigns && connected"
					class="omapi-dash__top-none omapi-dash__top-no-campaigns"
				/>
				<common-not-connected v-else class="omapi-dash__top-none"/>
			</div>
			<template v-slot:footer>
				<router-link v-if="connected" :to="{ name: 'campaigns' }" class="omapi-link-arrow-after">View All Campaigns</router-link>
			</template>
		</common-card>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { numbers } from '@/utils'

export default {
	data () {
		return {
			hasCampaigns : null,
		}
	},
	watch : {
		isLoading (isLoading) {
			if (!isLoading) {
				this.handleRequest()
			}
		},
	},
	mounted () {
		if (!this.isLoading) {
			this.handleRequest()
		}

		this.$bus.$on('fetchedMe', this.handleRequest)
	},
	beforeDestroy () {
		this.$bus.$off('fetchedMe', this.handleRequest)
	},
	computed : {
		...mapGetters([ 'connected', 'shouldFetchUser' ]),
		...mapGetters('dashboard', [ 'topCampaigns' ]),
		isLoading () {
			return this.shouldFetchUser || this.$store.getters.isLoading([ 'accountDash', 'campaigns', 'campaigns-refresh' ])
		},
	},
	methods : {
		...mapActions('campaigns', [ 'refreshDashboard' ]),
		/**
		 * Get the path to edit this campaign.
		 *
		 * @param {string} campaignId The campaign id/slug.
		 * @returns {string} The URI
		 */
		builderLink (campaignId) {
			return this.$urls.builderLink(campaignId)
		},
		withCommas (number) {
			return numbers.withCommas(number)
		},
		getRate (rate) {
			return parseFloat(parseFloat(rate).toFixed(2)) + '%'
		},
		afterConnect () {
			window.location.reload()
		},
		async handleRequest () {
			if (null !== this.hasCampaigns || this.isLoading) {
				return
			}

			this.hasCampaigns = 0 < this.topCampaigns.length

			if (!this.hasCampaigns) {
				await this.refreshDashboard()

				this.hasCampaigns = 0 < this.$store.state.campaigns.campaigns.length
			}
		},
	},
}
</script>
